import '../styles/OperationsContinueBand.css';
import React from 'react';

const DESTINATIONS = [
  { label: 'Back to dashboard', href: '/dashboard' },
  { label: 'New transfer', href: '/transfer' },
];

function OperationsContinueBand() {
  return (
    <section className="ocb-root" aria-labelledby="ocb-heading">
      <div className="ocb-panel">
        <div className="ocb-copy">
          <p className="ocb-micro">
            <span className="ocb-micro-tick" aria-hidden="true" />
            Servicing &amp; oversight
          </p>
          <h2 className="ocb-line" id="ocb-heading">
            Client account creation and transfers are supported, and their history stays accurate.
          </h2>
        </div>

        <div className="ocb-actions">
          {DESTINATIONS.map((destination) => (
            <a key={destination.href} className="ocb-control" href={destination.href}>
              <span className="ocb-control-label">{destination.label}</span>
              <span className="ocb-dial" aria-hidden="true" />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OperationsContinueBand;